export type PlatformResult = 'native-ios' | 'web-ios' | 'native-android' | 'web-android' | 'web-desktop';

// Minimal platform detection logic
export function resolvePlatform(): PlatformResult {
  const ua = navigator.userAgent || '';

  const isIOS = /iPhone|iPad|iPod/.test(ua);
  const isAndroid = /Android/.test(ua);
  const isHybrid = /wv/.test(ua) || /\bCordova\b/.test(ua);

  if (isIOS) {
    return isHybrid ? 'native-ios' : 'web-ios';
  } else if (isAndroid) {
    return isHybrid ? 'native-android' : 'web-android';
  } else {
    return 'web-desktop';
  }
}
